export default "__VITE_ASSET__5q0SvTgh__"